import { createContext } from 'react';

interface PartnershipContextType {
    sendSegmentEventForInternet: (eventNameType: any, eventData: any) => void;
}

export const PartnershipContext = createContext<PartnershipContextType>({
    sendSegmentEventForInternet: () => {},
});
